import React, { useState, FC } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { Box, makeStyles } from "@material-ui/core";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

const styles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingBottom: theme.spacing(2),
    "@media (max-width: 450px)": {
      paddingBottom: theme.spacing(1),
      "& input": {
        fontSize: "0.875rem",
      },
    },
    position: "relative",
  },
  label: {
    fontSize: "0.775rem",
    fontWeight: 500,
  },
  reactPhoneWrapper: {
    "& .special-label": {
      display: "none",
    },
    "& .form-control": {
      width: "100%",
      marginTop: theme.spacing(0.5),
      padding: theme.spacing(1.25, 2, 1.25, 6),
      fontSize: "0.775rem", // text-sm
      [theme.breakpoints.up("sm")]: {
        fontSize: "1rem", // text-base
        padding: theme.spacing(1.5, 2.5, 1.5, 6),
      },
      "@media (max-width: 450px)": {
        fontSize: "0.675rem", // text-base
        padding: theme.spacing(0.8, 1.75, 0.8, 6),
        marginTop: theme.spacing(0.25),
      },
      borderRadius: theme.shape.borderRadius * 3,
    },
    "& .flag-dropdown .selected-flag .flag": {
      width: "25px",
      height: "20px",
      marginTop: "-10px",
    },
  },
  borderError: {
    "& .form-control": {
      border: `1px solid ${theme.palette.error.main}`,
      "&:focus": {
        outline: "none",
        boxShadow: `0 0 0 2px ${theme.palette.error.main}`,
      },
      "&:hover": {
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
  },
  borderNormal: {
    "& .form-control": {
      border: "1px solid #e5e7eb;", // ~ border-gray-300
      "&:focus": {
        outline: "none",
        border: `1px solid ${theme.palette.primary.light}`,
        boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
        // ~ focus:ring-2 focus:ring-primary/20
      },
      "&:hover": {
        border: `1px solid ${theme.palette.primary.light}`,
      },
    },
  },
  labelContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(0.25),
    "@media (max-width: 450px)": {
      marginBottom: theme.spacing(0),
    },
  },
  error: {
    color: theme.palette.error.main,
  },
}));

interface CustomPhonePRops {
  name: string;
  label?: string;
  value?: string;
  onChange(name: string, phone: string): void;
  isSubmitted?: boolean;
  errorMessageId?: string;
}

const CustomPhone: FC<CustomPhonePRops> = (props) => {
  const {
    label,
    name,
    value,
    onChange: handlePhoneChange,
    isSubmitted,
    errorMessageId,
  } = props;
  const classes = styles({});
  const [phone, setPhone] = useState(value ? value : "");
  const handleChange = (phone: any) => {
    setPhone(phone);
    handlePhoneChange(name, phone);
  };
  const hasError = isSubmitted && !value;
  return (
    <Box className={classes.root}>
      {label && (
        <Box className={classes.labelContent}>
          <span
            className={classNames(classes.label, hasError && classes.error)}
          >
            {label}
          </span>
        </Box>
      )}
      <PhoneInput
        value={phone}
        onChange={handleChange}
        containerClass={classNames(
          classes.reactPhoneWrapper,
          hasError ? classes.borderError : classes.borderNormal,
        )}
        country={"fr"}
        inputProps={{
          required: true,
        }}
        autoFormat={false}
        enableLongNumbers={true}
      />
      {hasError && errorMessageId && (
        <span className={classes.error}>
          <FormattedMessage id={errorMessageId} />
        </span>
      )}
    </Box>
  );
};
export default CustomPhone;
